import React, { Component } from 'react';
import AuditBreadcrumb from './auditBreadcrumb';
import { MobileDateTimePicker } from '@mui/x-date-pickers';
import {
    FormLabel,
    TextField,
    IconButton,
    InputAdornment,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from '@mui/material';
import EventIcon from '@mui/icons-material/Event';
import SearchIcon from '@mui/icons-material/Search';

class AuditSearchMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            from_date: this.props.from_date,
            to_date: this.props.to_date,
            pickerOpened: false
        };
    }

    render() {
        return (
            <div>
                <AuditBreadcrumb onBtnExport={this.props.onBtnExport} />
                <div className="row" style={{ padding: '15px 12px 0 12px' }}>
                    {/* Date Range Section */}
                    <div className="col-12">
                        <div className="row align-items-end">
                            <div className="col-auto">
                                <FormLabel style={{ marginBottom: '8px', display: 'block' }}>Date Range</FormLabel>
                                <div className="dateRangeBar">
                                    <button
                                        className={
                                            'btn btn-info dateRangeBtn mr-1' +
                                            (this.props.date_range === 'today' ? ' active' : '')
                                        }
                                        onClick={() => this.props.updateDateRange('today')}
                                    >
                                        Today
                                    </button>
                                    <button
                                        className={
                                            'btn btn-info dateRangeBtn mr-1' +
                                            (this.props.date_range === 'week' ? ' active' : '')
                                        }
                                        onClick={() => this.props.updateDateRange('week')}
                                    >
                                        Week
                                    </button>
                                    <button
                                        className={
                                            'btn btn-info dateRangeBtn mr-1' +
                                            (this.props.date_range === 'month' ? ' active' : '')
                                        }
                                        onClick={() => this.props.updateDateRange('month')}
                                    >
                                        Month
                                    </button>
                                    <button
                                        className={
                                            'btn btn-info dateRangeBtn' +
                                            (this.props.date_range === 'custom' ? ' active' : '')
                                        }
                                    >
                                        Custom
                                    </button>
                                </div>
                            </div>
                            <div className="col-auto">
                                <MobileDateTimePicker
                                    value={this.state.pickerOpened ? this.state.from_date : this.props.from_date}
                                    onChange={(dateTime) => this.setState({ from_date: dateTime })}
                                    onOpen={() =>
                                        this.setState({ from_date: this.props.from_date, pickerOpened: true })
                                    }
                                    onClose={() => this.setState({ pickerOpened: false })}
                                    onAccept={(dateTime) =>
                                        this.props.handleDateFiltersChange(dateTime.$d, 'from_date')
                                    }
                                    label="From Date"
                                    renderInput={(props) => (
                                        <TextField
                                            {...props}
                                            size="small"
                                            sx={{ width: 200 }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton edge="end" size="small">
                                                            <EventIcon />
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    )}
                                />
                            </div>
                            <div className="col-auto">
                                <MobileDateTimePicker
                                    value={this.state.pickerOpened ? this.state.to_date : this.props.to_date}
                                    onChange={(dateTime) => this.setState({ to_date: dateTime })}
                                    onOpen={() => this.setState({ to_date: this.props.to_date, pickerOpened: true })}
                                    onClose={() => this.setState({ pickerOpened: false })}
                                    onAccept={(dateTime) => this.props.handleDateFiltersChange(dateTime.$d, 'to_date')}
                                    label="To Date"
                                    renderInput={(props) => (
                                        <TextField
                                            {...props}
                                            size="small"
                                            sx={{ width: 200 }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton edge="end" size="small">
                                                            <EventIcon />
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Filters Row */}
                <div className="row" style={{ padding: '10px 12px' }}>
                    <div className="col-12">
                        <div className="row align-items-center" style={{ gap: '10px' }}>
                            <div className="col-auto">
                                <FormControl size="small" sx={{ minWidth: 200 }}>
                                    <InputLabel>Event Type</InputLabel>
                                    <Select
                                        value={this.props.eventTypeFilter || ''}
                                        label="Event Type"
                                        onChange={(e) => this.props.onEventTypeChange(e.target.value)}
                                    >
                                        <MenuItem value="">
                                            <em>All Event Types</em>
                                        </MenuItem>
                                        {this.props.eventTypes &&
                                            this.props.eventTypes.map((type) => (
                                                <MenuItem key={type} value={type}>
                                                    {type}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className="col-auto">
                                <FormControl size="small" sx={{ minWidth: 200 }}>
                                    <InputLabel>User</InputLabel>
                                    <Select
                                        value={this.props.userFilter || ''}
                                        label="User"
                                        onChange={(e) => this.props.onUserChange(e.target.value)}
                                    >
                                        <MenuItem value="">
                                            <em>All Users</em>
                                        </MenuItem>
                                        {this.props.users &&
                                            this.props.users.map((user) => (
                                                <MenuItem key={user} value={user}>
                                                    {user}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className="col-auto">
                                <TextField
                                    label="Search"
                                    placeholder="Search all columns..."
                                    variant="outlined"
                                    size="small"
                                    id="reset-form"
                                    sx={{ width: 250 }}
                                    onChange={this.props.onFilterTextChange}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon fontSize="small" />
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </div>
                            <div className="col-auto">
                                <button className="btn btn-danger" onClick={() => this.props.clearFilter()}>
                                    <i className="fa fa-times" aria-hidden="true"></i> Clear Filter
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AuditSearchMenu;
